import type { SVGProps } from "react";

export function IconBlackBriefcase(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9165 2.25H16.4165V5.25H19.6665C21.1853 5.25 22.4165 6.48122 22.4165 8V11.75H2.9165V8C2.9165 6.48122 4.14772 5.25 5.6665 5.25H8.9165V2.25ZM2.9165 13.25V21.75H22.4165V13.25H13.4165V16.25H11.9165V13.25H2.9165ZM14.9165 3.75V5.25H10.4165V3.75H14.9165Z"
        fill="#0B0C17"
      />
    </svg>
  );
}
